import React, {useState} from 'react'
import './searchBar.css';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
function SearchBar({placeholder, data, searchDest}) {
    const [filteredData, setFilteredData] = useState([]);
    const [wordEntered, setWordEntered] = useState("");
    const handleFilter =(event) => {
       const searchWord = event.target.value
       setWordEntered(searchWord);
       const newFilter = data.filter((value) => {
            return value.Name.toLowerCase().includes(searchWord.toLowerCase());
       });
       if (searchWord == "") {
        setFilteredData([]);
       } else {
        setFilteredData(newFilter);
       }
    };
    const clearInput = () => {
        setFilteredData([]);
        setWordEntered("");
    }
  return (
    <div className="search">
        <div className="searchInputs">
            <input type="text" placeholder={placeholder} value={wordEntered} onChange={handleFilter}/>
            <div className="SearchIcon">
                {wordEntered.length === 0 ? (
                <SearchIcon />
                ) : ( 
                <CloseIcon 
                id="clearBtn" onClick={clearInput}/>)}
                
            </div>
        </div>
        {filteredData.length != 0 && (
        <div className="dataResult">
        {filteredData.slice(0, 15).map((value, key)=> {
            return (
            <a className="dataItem">
                <button className="searchButton" onClick={() => {
                  searchDest(value.id)
                }}><p>{value.Name}</p></button>
            </a>
            );
        })}
        </div>
)}
    </div>
  );
}

export default SearchBar;